// extracted by mini-css-extract-plugin
export var dividerLine = "_7e-3";
export var itemImage = "_7e-9";
export var lightDivider = "_7e-4";
export var modalContent = "_7e-5";
export var modalContentCompact = "_7e-6";
export var productCard = "_7e-a";
export var productImage = "_7e-b";
export var productImageCompact = "_7e-7";
export var productImagePlaceholder = "_7e-c";
export var productImagePlaceholderCompact = "_7e-8";
export var progressBarBackground = "_7e-1";
export var progressBarContainer = "_7e-0";
export var progressBarFill = "_7e-2";